import { IViagsLeaveInfo } from "../../../../../services/viags/application-for-leave.service";

export const UserHelper = {
  getBranchTitle(code: string) {
    const branchList: { [key: string]: string } = {
      KCQ: "Khối cơ quan",
      TSN: "Chi nhánh Tân Sơn Nhât",
    };
    return branchList[code];
  },
  getDepartmentInfo(userInfo: IViagsLeaveInfo) {
    const departmentInfo: Record<string, string> = {
      eDepartment: "",
      eUnit: "",
      eTeam: "",
    };
    const depList = userInfo.listDepartment;
    let currentIndex = depList[0].code === "KCQ" ? 1 : 0;
    for (const key in departmentInfo) {
      let value = "";
      if (currentIndex > depList.length - 1) {
        value = `${depList.at(-1)!.code}|${depList.at(-1)!.name_VN}`;
      } else {
        value = `${depList[currentIndex].code}|${depList[currentIndex].name_VN}`;
      }
      departmentInfo[key] = value;
      currentIndex++;
    }
    return departmentInfo;
  },
  inGroup(
    codeJobTitle: string, // ex. "CNTT-DTQTCNTT"
    group: string[]
  ): Boolean {
    if (!codeJobTitle) return false;
    const codeList: string[] = codeJobTitle.split("-");
    for (const position of group) {
      const isMatched = codeList.some((e: string) => e.startsWith(position));
      if (isMatched) return true;
    }
    return false;
  },
  // inGroup(titleCode: string, titleCodeList: string[]) {
  //   if (!titleCode) return false;
  //   return titleCodeList.some((t) => titleCode.startsWith(t));
  // },
};
